(function () {
  'use strict';
  var WORKER_BASE = 'https://api.tinytunesongs.com';

  function escapeHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var ENTITY_SKIN_SWATCHES = [
    ['porcelain', 'Porcelain', '#F5DCC6'], ['fair', 'Fair', '#EAC29B'], ['light', 'Light', '#D9A876'],
    ['lightmedium', 'Light Medium', '#C08858'], ['medium', 'Medium', '#A36A42'], ['mediumdeep', 'Medium Deep', '#8B5A34'],
    ['deep', 'Deep', '#6B4226'], ['richdeep', 'Rich Deep', '#4A2C17'],
  ];

  function ageRangeToGroup(r) {
    var map = { '0-2': 'baby', '2-4': 'toddler', '5-9': 'young_child', '10-13': 'preteen', '14-19': 'teen',
      '20-49': 'adult', '50-59': 'senior50', '60-69': 'senior60', '70+': 'senior70plus' };
    return map[r] || '';
  }

  function compileEntityDescription(kind, sel) {
    if (kind === 'pet') {
      return {
        petType: sel.species || '',
        breed: [sel.size, sel.furlength ? sel.furlength + ' fur' : ''].filter(Boolean).join(', '),
        color: [sel.furcolor, sel.extra].filter(Boolean).join(' — '),
      };
    }
    if (kind === 'horse') {
      return {
        petType: 'horse',
        breed: sel.manecolor ? sel.manecolor + ' mane and tail' : '',
        color: [sel.coatcolor, sel.markings && sel.markings !== 'None' ? sel.markings : '', sel.extra].filter(Boolean).join(' — '),
      };
    }
    var parts = [];
    if (sel.gender) parts.push(sel.gender);
    if (sel.age) parts.push('around ' + sel.age + ' years old');
    if (sel.body) parts.push(sel.body + ' build');
    if (sel.skinHexLabel) parts.push(sel.skinHexLabel.toLowerCase() + ' skin tone (approximate reference color ' + (sel.skinHex || '') + ')');
    if (sel.haircolor === 'Bald / No hair') parts.push('bald / no hair');
    else if (sel.hairlength && sel.haircolor) parts.push(sel.hairlength.toLowerCase() + ' ' + sel.haircolor.toLowerCase() + ' hair');
    var desc = parts.join(', ');
    if (sel.extra) desc = sel.extra.trim().replace(/[.\s]+$/, '') + (desc ? '. ' + desc : '');
    return { description: desc, ageGroup: sel.age ? ageRangeToGroup(sel.age) : '' };
  }

  function readAndResizeImageFile(file, maxDim, quality, onSuccess, onError) {
    var reader = new FileReader();
    reader.onload = function () {
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (w > maxDim || h > maxDim) { var sc = Math.min(maxDim / w, maxDim / h); w = Math.round(w * sc); h = Math.round(h * sc); }
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        try { onSuccess(c.toDataURL('image/jpeg', quality)); } catch (e) { onError && onError(e); }
      };
      img.onerror = function () { onSuccess(reader.result); };
      img.src = reader.result;
    };
    reader.onerror = function () { onError && onError(new Error('read failed')); };
    reader.readAsDataURL(file);
  }

  function uploadEntityPhotoFile(key, kind, label, code, file, statusEl, ageGroup, gender, species, onSuccess) {
    statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Preparing photo…';
    readAndResizeImageFile(file, 1600, 0.85, function (dataUrl) {
      statusEl.innerHTML = '<span class="ttq-loading-dot"></span> Creating their character…';
      fetch(WORKER_BASE + '/upload-entity-photo', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code, entity_key: key, entity_label: label, kind: kind, photo: dataUrl,
          consent_confirmed: true, age_group: ageGroup || '', gender: gender || '', species: species || '' }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (out) {
          if (out && out.ok) { onSuccess(out.imageUrl || '', out.attemptsRemaining); return; }
          var rem = out && typeof out.attemptsRemaining === 'number' ? out.attemptsRemaining : null;
          var msg = escapeHtml((out && out.error) || "Couldn't upload — please try again.");
          if (rem === 0) msg += ' No more retries for this photo.';
          else if (rem === 1) msg += ' You have 1 more try.';
          statusEl.innerHTML = '<span style="color:#b42318;">' + msg + '</span>';
        })
        .catch(function () { statusEl.innerHTML = '<span style="color:#b42318;">Something went wrong — please try again.</span>'; });
    }, function () { statusEl.innerHTML = '<span style="color:#b42318;">Couldn\'t read that photo — try a different one.</span>'; });
  }

  var TT_FEMALE_RE = /\b(grand ?ma|grandmother|nana|nanna|memaw|mamaw|meemaw|mimi|gigi|granny|gran|mom|mommy|mother|mama|aunt|auntie|aunty|tia|sister|sis|niece|daughter|wife)\b/i;
  var TT_MALE_RE = /\b(grand ?pa|grandfather|papa|pawpaw|poppy|pop|pops|grandad|granddad|dad|daddy|father|uncle|tio|brother|bro|nephew|son|husband)\b/i;
  var TT_ADULT_RE = /\b(grand ?ma|grandmother|nana|nanna|memaw|mamaw|meemaw|mimi|gigi|granny|gran|grand ?pa|grandfather|papa|pawpaw|poppy|grandad|granddad|mom|mommy|mother|mama|dad|daddy|father|aunt|auntie|aunty|uncle|tia|tio)\b/i;
  var TTIC_AGES = [['0-2', 'Baby'], ['2-4', 'Toddler'], ['5-9', 'Kid'], ['10-13', 'Preteen'], ['14-19', 'Teen'], ['20-49', 'Adult'], ['50-59', '50s'], ['60-69', '60s'], ['70+', '70+']];
  var TTIC_ADULT_AGES = ['20-49', '50-59', '60-69', '70+'];
  // Photo path: the photo shows their age, so no decades (they only make people look older than they are)
  var TTIC_PHOTO_AGES = TTIC_AGES.filter(function (a) { return ['50-59', '60-69', '70+'].indexOf(a[0]) === -1; });
  function ttGuessGender(label) { var s = String(label || ''); return TT_FEMALE_RE.test(s) ? 'Female' : TT_MALE_RE.test(s) ? 'Male' : ''; }

  function ensureStyles() {
    if (document.getElementById('ttInlineCastStyles')) return;
    var s = document.createElement('style');
    s.id = 'ttInlineCastStyles';
    s.textContent =
      '@keyframes ttSpin{to{transform:rotate(360deg)}}' +
      '.ttq-loading-dot{display:inline-block;width:12px;height:12px;border-radius:50%;border:2.5px solid rgba(79,163,209,.25);border-top-color:#4fa3d1;animation:ttSpin .8s linear infinite;vertical-align:-1px;margin-right:4px}' +
      '.ttic-section{position:relative;margin:8px 0;padding:26px 16px 16px;border-radius:22px;background:linear-gradient(180deg,#fffdf7,#fff6e3);border:1.5px solid rgba(240,180,41,.4);box-shadow:0 12px 30px rgba(240,168,0,.14);scroll-margin-top:16px;text-align:left}' +
      '.ttic-badge{position:absolute;top:-12px;left:16px;background:#111827;color:#fff;font-family:Nunito,sans-serif;font-size:10.5px;font-weight:900;letter-spacing:.06em;padding:6px 14px;border-radius:999px}' +
      '.ttic-title{font-family:Fraunces,serif;font-weight:600;font-size:21px;color:#16324a;text-align:center}' +
      '.ttic-sub{font-family:Nunito,sans-serif;font-size:13px;font-weight:700;line-height:1.45;color:#6b7280;text-align:center;margin:4px 0 8px}' +
      '.ttic-progress{text-align:center;font-family:Nunito,sans-serif;font-size:12px;font-weight:900;color:#b8860b;margin-bottom:12px}' +
      '.ttic-cards{display:grid;gap:10px}' +
      '.ttic-card{background:#fff;border:1.5px solid rgba(26,58,92,.1);border-radius:16px;padding:14px;text-align:left}' +
      '.ttic-card.is-done{border-color:rgba(22,163,74,.35);background:#f7fdf9}' +
      '.ttic-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px}' +
      '.ttic-name{font-family:Nunito,sans-serif;font-size:16px;font-weight:900;color:#16324a}' +
      '.ttic-actions{display:flex;gap:8px}' +
      '.ttic-btn{flex:1;border:none;border-radius:12px;padding:13px 10px;font-family:Nunito,sans-serif;font-size:14px;font-weight:900;cursor:pointer}' +
      '.ttic-photo{background:linear-gradient(135deg,#f9c846,#f0a800);color:#111827}' +
      '.ttic-desc{background:#e8f4fb;color:#3c8ab3}' +
      '.ttic-q{font-family:Nunito,sans-serif;font-size:12px;font-weight:800;color:#6b7280;margin:12px 0 6px}' +
      '.ttic-chips{display:flex;flex-wrap:wrap;gap:6px}' +
      '.ttic-chip{border:1.5px solid rgba(26,58,92,.14);background:#f8fbfd;border-radius:999px;padding:8px 12px;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;color:#374151;cursor:pointer}' +
      '.ttic-chip.sel{border-color:#4fa3d1;background:#e8f4fb;color:#3c8ab3}' +
      '.ttic-sw{width:34px;height:34px;border-radius:50%;border:2px solid rgba(15,23,42,.1);cursor:pointer;padding:0}' +
      '.ttic-sw.sel{border:3px solid #4fa3d1;box-shadow:0 0 0 3px rgba(79,163,209,.25)}' +
      '.ttic-text{width:100%;min-height:54px;border-radius:12px;border:1.5px solid rgba(79,163,209,.3);padding:10px 12px;font-family:Nunito,sans-serif;font-size:14px;box-sizing:border-box;resize:vertical}' +
      '.ttic-save{width:100%;margin-top:14px;border:none;border-radius:12px;padding:14px;background:linear-gradient(135deg,#4fa3d1,#3c8ab3);color:#fff;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;cursor:pointer}' +
      '.ttic-save:disabled{opacity:.45;cursor:default}' +
      '.ttic-link{background:none;border:none;color:#6b7280;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:800;text-decoration:underline;cursor:pointer;padding:4px}' +
      '.ttic-consent{display:flex;gap:8px;align-items:flex-start;background:#f8fbfd;border:1px solid rgba(79,163,209,.2);border-radius:12px;padding:10px;font-family:Nunito,sans-serif;font-size:12px;font-weight:700;line-height:1.45;color:#374151;margin-bottom:4px}' +
      '.ttic-filebtn{display:block;text-align:center;margin-top:14px;border-radius:12px;padding:14px;background:linear-gradient(135deg,#f9c846,#f0a800);color:#111827;font-family:Nunito,sans-serif;font-size:15px;font-weight:900;cursor:pointer}' +
      '.ttic-filebtn.off{opacity:.45;pointer-events:none}' +
      '.ttic-preview{display:block;width:140px;height:140px;object-fit:cover;border-radius:50%;border:4px solid #f0b429;margin:6px auto 10px}' +
      '.ttic-done{display:flex;align-items:center;gap:10px}' +
      '.ttic-done img{width:46px;height:46px;border-radius:50%;object-fit:cover;object-position:center 15%;border:2px solid #16a34a}' +
      '.ttic-done-ico{width:46px;height:46px;border-radius:50%;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0}' +
      '.ttic-done-text{flex:1;font-family:Nunito,sans-serif;font-size:13px;font-weight:800;line-height:1.35;color:#16324a}' +
      '.ttic-check{color:#16a34a;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:900}' +
      '.ttic-status{margin-top:8px;font-family:Nunito,sans-serif;font-size:12.5px;font-weight:700;color:#6b7280;text-align:center}' +
      '.ttic-footer{margin-top:14px;text-align:center}' +
      '.ttic-continue{width:100%;border:none;border-radius:14px;padding:16px;background:#111827;color:#fff;font-family:Nunito,sans-serif;font-size:15.5px;font-weight:900;cursor:pointer}' +
      '.ttic-continue:disabled{opacity:.6;cursor:progress}' +
      '.ttic-review-img{display:block;width:100%;max-width:240px;aspect-ratio:3/4;object-fit:cover;object-position:center 15%;border-radius:16px;border:3px solid #f0b429;margin:4px auto 10px;background:#f8fbfd}' +
      '.ttic-review-q{text-align:center;font-family:Fraunces,serif;font-weight:600;font-size:18px;color:#16324a}' +
      '.ttic-retry{display:block;width:100%;margin-top:8px;padding:12px;border-radius:12px;border:1.5px solid rgba(26,58,92,.16);background:#fff;font-family:Nunito,sans-serif;font-size:14px;font-weight:900;color:#16324a;cursor:pointer}';
    document.head.appendChild(s);
  }

  function chips(field, options, current) {
    return '<div class="ttic-chips">' + options.map(function (o) {
      return '<button type="button" class="ttic-chip' + (current === o[0] ? ' sel' : '') + '" data-f="' + field + '" data-v="' + escapeHtml(o[0]) + '">' + escapeHtml(o[1]) + '</button>';
    }).join('') + '</div>';
  }
  function q(text) { return '<div class="ttic-q">' + text + '</div>'; }
  function opts(arr) { return arr.map(function (x) { return [x, x]; }); }

  // Full-screen check: tap the picture to zoom in on the face (eyes, hair, smile)
  function openZoom(url) {
    if (!url) return;
    var ov = document.createElement('div');
    ov.style.cssText = 'position:fixed;inset:0;z-index:10300;background:rgba(10,14,26,.94);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:20px;';
    ov.innerHTML =
      '<div style="width:min(92vw,520px);height:min(74vh,700px);overflow:hidden;border-radius:20px;background:#fff;">' +
      '<img src="' + escapeHtml(url) + '" alt="" style="width:100%;height:100%;object-fit:contain;transition:transform .35s ease;transform-origin:50% 18%;cursor:zoom-in;"></div>' +
      '<div style="color:#fff;font-family:Nunito,sans-serif;font-weight:800;font-size:14px;text-align:center;">Tap the picture to zoom in on the face 👀</div>' +
      '<button type="button" style="padding:13px 30px;border:none;border-radius:12px;background:#fff;color:#111827;font-family:Nunito,sans-serif;font-weight:900;font-size:15px;cursor:pointer;">Done</button>';
    document.body.appendChild(ov);
    document.documentElement.style.overflow = 'hidden';
    var zImg = ov.querySelector('img');
    var zoomed = false;
    zImg.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomed = !zoomed;
      zImg.style.transform = zoomed ? 'scale(2.4)' : 'none';
      zImg.style.cursor = zoomed ? 'zoom-out' : 'zoom-in';
    });
    function close() { ov.remove(); document.documentElement.style.overflow = ''; }
    ov.querySelector('button').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  }

  // One card per detected person or pet: Describe, or (photo mode) upload a photo.
  function mountCard(ent, o) {
    ensureStyles();
    var card = document.createElement('div');
    card.className = 'ttic-card';
    card.dataset.key = ent.key;
    var kind = ent.kind === 'pet' || ent.kind === 'horse' ? 'pet' : ent.kind === 'unknown' ? '' : 'person';
    var guessed = ttGuessGender(ent.label);
    var adultOnly = TT_ADULT_RE.test(String(ent.label || ''));
    var sel = { body: 'Average', ethnicity: 'Skip' };
    if (guessed) sel.gender = guessed;
    var ph = { gender: guessed ? guessed.toLowerCase() : '', age: '', rel: '', species: '', file: null, preview: '' };
    var skipPhotoAge = adultOnly || !!o.adult; // Mom, Grandma, "Add yourself"…: obviously an adult, so don't ask
    if (skipPhotoAge) ph.age = '20-49';
    var state = 'choose', thumb = '', statusMsg = '';
    var review = null, descRedos = 0; // the generated image waiting for "✓ This is them"
    var label = escapeHtml(ent.label);
    if (o.done) { state = 'done'; thumb = o.thumb || ''; } // already added: show as "✓ Added" (tap Edit to change)

    function ages() { return adultOnly ? TTIC_AGES.filter(function (a) { return TTIC_ADULT_AGES.indexOf(a[0]) !== -1; }) : TTIC_AGES; }
    function head(right) {
      var av = thumb ? '<img src="' + escapeHtml(thumb) + '" alt="">' : escapeHtml(String(ent.label || '?').charAt(0).toUpperCase());
      return '<div class="ttic-head"><span class="ttic-av">' + av + '</span><div class="ttic-name">' + label + (kind === 'pet' ? ' 🐾' : '') + '</div>' + (right || '') + '</div>';
    }
    function isHorse() { return sel.species === 'Horse'; }
    function describeReady() {
      if (kind === 'pet') return !!sel.species && (isHorse() ? !!sel.coatcolor : !!sel.furcolor);
      return !!sel.gender && !!sel.age && !!sel.skin && !!sel.haircolor && (sel.haircolor === 'Bald / No hair' || !!sel.hairlength);
    }
    function photoReady() {
      if (!window.ttEntityPhotoConsentGiven) return false;
      if (kind === 'pet') return !!ph.species;
      return !!ph.gender && !!ph.age && (ph.age !== '5-9' || !!ph.rel);
    }

    function render() {
      var h = '';
      card.classList.toggle('is-done', state === 'done');
      if (state === 'done') {
        h = head('<span class="ttic-check">✓ Added</span>') + '<div class="ttic-done">' +
          (thumb ? '<img src="' + thumb + '" alt="" data-act="zoom" style="cursor:zoom-in;">' : '<span class="ttic-done-ico">✍️</span>') +
          '<div class="ttic-done-text">' + label + ' is cast in the movie!</div>' +
          '<button type="button" class="ttic-link" data-act="edit">Edit</button></div>';
      } else if (state === 'choose') {
        h = head();
        if (!kind) {
          h += q('Is ' + label + ' a person or a pet?') + chips('_kind', [['person', '🧑 Person'], ['pet', '🐾 Pet']], '');
        } else if (o.photoOnly) {
          state = 'photo'; // these flows only take a photo → straight to it
          render();
          return;
        } else {
          h += '<div class="ttic-actions">' +
            (o.allowPhoto ? '<button type="button" class="ttic-btn ttic-photo" data-act="photo">📸 Use a photo</button>' : '') +
            '<button type="button" class="ttic-btn ttic-desc" data-act="describe">✍️ Describe</button></div>';
        }
      } else if (state === 'describe') {
        h = head('<button type="button" class="ttic-link" data-act="back">‹ Back</button>');
        if (kind === 'pet') {
          h += q('What kind of pet?') + chips('species', [['Dog', '🐶 Dog'], ['Cat', '🐱 Cat'], ['Horse', '🐴 Horse'], ['Other', '🐾 Other']], sel.species);
          if (isHorse()) {
            h += q('Coat color') + chips('coatcolor', opts(['Chestnut', 'Bay', 'Black', 'Palomino', 'White / Gray', 'Brown', 'Spotted / Pinto']), sel.coatcolor);
            h += q('Mane & tail') + chips('manecolor', opts(['Black', 'Brown', 'Blonde / Flaxen', 'White / Gray', 'Same as coat']), sel.manecolor);
            h += q('Markings') + chips('markings', opts(['None', 'White blaze/stripe on face', 'White socks/legs', 'Spots']), sel.markings);
          } else if (sel.species) {
            h += q('Size') + chips('size', opts(['Small', 'Medium', 'Large']), sel.size);
            h += q('Fur color') + chips('furcolor', opts(['Black', 'White', 'Brown', 'Golden / Tan', 'Gray', 'Spotted / Mixed']), sel.furcolor);
            h += q('Fur length') + chips('furlength', opts(['Short', 'Medium', 'Long']), sel.furlength);
          }
          h += q('Anything else? (optional)') + '<textarea class="ttic-text" data-f="extra" placeholder="e.g. breed, floppy ears, one blue eye">' + escapeHtml(sel.extra || '') + '</textarea>';
        } else {
          if (!guessed) h += q('Male or female?') + chips('gender', opts(['Female', 'Male']), sel.gender);
          h += q('Age') + chips('age', ages(), sel.age);
          h += q('Skin tone') + '<div class="ttic-chips">' + ENTITY_SKIN_SWATCHES.map(function (sw) {
            return '<button type="button" class="ttic-sw' + (sel.skin === sw[0] ? ' sel' : '') + '" data-f="skin" data-v="' + sw[0] + '" aria-label="' + sw[1] + '" style="background:' + sw[2] + ';"></button>';
          }).join('') + '</div>';
          h += q('Hair color') + chips('haircolor', opts(['Black', 'Brown', 'Blonde', 'Red', 'Gray', 'White', 'Bald / No hair']), sel.haircolor);
          if (sel.haircolor !== 'Bald / No hair') h += q('Hair length') + chips('hairlength', opts(['Short', 'Medium', 'Long']), sel.hairlength);
          if (sel.haircolor !== 'Bald / No hair') h += q('Hair type') + chips('hairtype', opts(['Straight', 'Wavy', 'Curly', 'Coily']), sel.hairtype);
          if (sel.age === '5-9') h += q('Compared to ' + escapeHtml(o.starName || 'your star') + '?') + chips('height', [['shorter', 'Younger & shorter'], ['same', 'About the same'], ['taller', 'Older & taller']], sel.height);
          h += q('Build') + chips('body', opts(['Slim', 'Average', 'Athletic', 'Heavyset']), sel.body);
          h += q('Ethnicity (optional)') + chips('ethnicity', opts(['White', 'Black', 'Hispanic', 'Asian', 'Mixed', 'Skip']), sel.ethnicity);
          h += q('Anything else? (optional)') + '<textarea class="ttic-text" data-f="extra" placeholder="e.g. glasses, beard, curly hair, always wears a hat">' + escapeHtml(sel.extra || '') + '</textarea>';
        }
        h += '<button type="button" class="ttic-save" data-act="save"' + (describeReady() ? '' : ' disabled') + '>Save ' + label + ' ✓</button>';
        if (statusMsg) h += '<div class="ttic-status">' + statusMsg + '</div>';
      } else if (state === 'photo') {
        h = head('<button type="button" class="ttic-link" data-act="back">‹ Back</button>');
        if (!window.ttEntityPhotoConsentGiven) {
          h += '<label class="ttic-consent"><input type="checkbox" class="ttic-consent-cb" style="width:18px;height:18px;flex-shrink:0;accent-color:#4fa3d1;margin-top:1px;">' +
            '<span>I confirm I have permission from each person whose photo I add here (or from their parent or legal guardian if they are under 18), and I authorize TinyTunes to use these photos to create animated characters. I\'ve read the <a href="/pages/photo-likeness-biometric-privacy-notice" target="_blank" style="color:#3c8ab3;">Photo Likeness &amp; Biometric Privacy Notice</a>. You\'ll only be asked once.</span></label>';
        }
        if (kind === 'pet') {
          h += q('What kind of pet?') + chips('p_species', [['dog', '🐶 Dog'], ['cat', '🐱 Cat'], ['horse', '🐴 Horse'], ['other', '🐾 Other']], ph.species);
        } else {
          if (!guessed) h += q('Male or female?') + chips('p_gender', [['female', 'Female'], ['male', 'Male']], ph.gender);
          if (!skipPhotoAge) h += q('About how old?') + chips('p_age', TTIC_PHOTO_AGES, ph.age);
          if (ph.age === '5-9') h += q('Compared to ' + escapeHtml(o.starName || 'your star') + '?') + chips('p_rel', [['younger', 'Younger'], ['same', 'Same age'], ['older', 'Older']], ph.rel);
        }
        h += '<label class="ttic-filebtn' + (photoReady() ? '' : ' off') + '">📸 Choose ' + label + '\'s photo<input type="file" accept="image/*" class="ttic-file" style="display:none;"></label>';
        if (statusMsg) h += '<div class="ttic-status">' + statusMsg + '</div>';
      } else if (state === 'confirm') {
        h = head() + '<img class="ttic-preview" src="' + ph.preview + '" alt="">' +
          '<div style="text-align:center;font-family:Nunito,sans-serif;font-size:14px;font-weight:800;color:#16324a;margin-bottom:6px;">Is this ' + label + '?</div>' +
          '<button type="button" class="ttic-save" data-act="upload">✓ Yes, that\'s ' + label + '</button>' +
          '<div style="text-align:center;margin-top:6px;"><button type="button" class="ttic-link" data-act="photo">Pick a different photo</button></div>';
      } else if (state === 'review') {
        h = head() +
          '<img class="ttic-review-img" data-act="zoom" src="' + escapeHtml(review.url) + '" alt="" style="cursor:zoom-in;">' +
          '<div style="text-align:center;margin:-4px 0 8px;font-family:Nunito,sans-serif;font-size:12px;font-weight:800;color:#9ca3af;">Tap the picture to check up close 👀</div>' +
          '<div class="ttic-review-q">Does this look like ' + label + '?</div>' +
          '<button type="button" class="ttic-save" data-act="approve">✓ Yes, this is ' + label + '</button>' +
          (review.canRetry
            ? '<button type="button" class="ttic-retry" data-act="retry">' +
              (review.from === 'photo' ? '↻ Not quite, try a different photo' : '✏️ Not quite, change the details') + '</button>'
            : '<div class="ttic-status">That was the last redo, so this is the version we\'ll use.</div>');
      } else if (state === 'working') {
        h = head() + '<div class="ttic-upload-status ttic-status" style="padding:12px 0;"></div>' +
          '<div style="text-align:center;"><button type="button" class="ttic-link" data-act="photo">Use a different photo</button></div>';
      }
      card.innerHTML = h;
    }

    function markDone(url) {
      thumb = url || '';
      state = 'done';
      statusMsg = '';
      render();
      if (o.onDone) o.onDone(ent.key, thumb);
    }

    function saveDescribe() {
      var finalKind = kind === 'pet' ? (isHorse() ? 'horse' : 'pet') : 'person';
      var compiled = compileEntityDescription(finalKind, sel);
      if (finalKind === 'person' && sel.ethnicity && sel.ethnicity !== 'Skip') {
        compiled.description = (compiled.description ? compiled.description + ', ' : '') + sel.ethnicity.toLowerCase() + ' ethnicity';
      }
      // Kids 5–9: younger/older than the star → the Worker's hard sizing rules
      if (finalKind === 'person' && sel.age === '5-9' && sel.height === 'shorter') compiled.ageGroup = 'young_child_younger';
      if (finalKind === 'person' && sel.age === '5-9' && sel.height === 'taller') compiled.ageGroup = 'young_child_older';
      var payload = Object.assign({ key: ent.key, kind: finalKind }, compiled);
      statusMsg = '<span class="ttq-loading-dot"></span> Saving…';
      render();
      fetch(WORKER_BASE + '/save-entity-descriptions', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: o.code, descriptions: [payload] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('save failed');
          statusMsg = '<span class="ttq-loading-dot"></span> Drawing ' + label + '… about 20 seconds';
          render();
          return fetch(WORKER_BASE + '/generate-entity-previews', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: o.code, entities: [{ key: ent.key, label: ent.label, kind: finalKind }] }),
          })
            .then(function (r2) { return r2.json().catch(function () { return {}; }); })
            .catch(function () { return {}; })
            .then(function (out) {
              var hit = out && out.entities && out.entities.filter(function (x) { return x.key === ent.key; })[0];
              if (hit && hit.imageUrl) {
                review = { url: hit.imageUrl, from: 'describe', canRetry: descRedos < 2 };
                state = 'review';
                statusMsg = '';
                render();
              } else {
                markDone(''); // couldn't draw a preview: their description is still saved
              }
            });
        })
        .catch(function () { statusMsg = '<span style="color:#b42318;">Couldn\'t save — tap Save to try again.</span>'; render(); });
    }

    function startUpload() {
      if (!ph.file) return;
      var finalKind = kind === 'pet' ? 'pet' : 'person';
      var group = '';
      if (finalKind === 'person') {
        group = ageRangeToGroup(ph.age);
        if (group === 'young_child' && ph.rel === 'younger') group = 'young_child_younger';
        if (group === 'young_child' && ph.rel === 'older') group = 'young_child_older';
      }
      var file = ph.file, preview = ph.preview;
      state = 'working';
      render();
      uploadEntityPhotoFile(ent.key, finalKind, ent.label, o.code, file, card.querySelector('.ttic-upload-status'), group, ph.gender || '', ph.species || '', function (url, rem) {
        if (!url) { markDone(preview); return; }
        review = { url: url, from: 'photo', canRetry: rem !== 0 };
        state = 'review';
        render();
      });
    }

    card.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-act],[data-f]');
      if (!t || !card.contains(t) || t.tagName === 'TEXTAREA') return;
      var act = t.getAttribute('data-act');
      if (act) {
        if (act === 'edit' || act === 'back') { state = 'choose'; statusMsg = ''; render(); return; }
        if (act === 'describe') { state = 'describe'; statusMsg = ''; render(); return; }
        if (act === 'photo') { state = 'photo'; statusMsg = ''; ph.file = null; render(); return; }
        if (act === 'save') { if (describeReady()) saveDescribe(); return; }
        if (act === 'upload') { startUpload(); return; }
        if (act === 'zoom') { openZoom(t.getAttribute('src')); return; }
        if (act === 'approve') { markDone(review ? review.url : ''); return; }
        if (act === 'retry') {
          if (review && review.from === 'describe') { descRedos++; state = 'describe'; } // keeps their answers, they adjust and redraw
          else { state = 'photo'; ph.file = null; }
          statusMsg = '';
          render();
          return;
        }
        return;
      }
      var f = t.getAttribute('data-f'), v = t.getAttribute('data-v');
      if (!f || v === null) return;
      if (f === '_kind') { kind = v; render(); return; }
      if (f.indexOf('p_') === 0) {
        ph[f.slice(2)] = v;
        if (f === 'p_age' && v !== '5-9') ph.rel = '';
        render();
        return;
      }
      sel[f] = v;
      if (f === 'skin') ENTITY_SKIN_SWATCHES.forEach(function (sw) { if (sw[0] === v) { sel.skinHexLabel = sw[1]; sel.skinHex = sw[2]; } });
      if (f === 'haircolor' && v === 'Bald / No hair') { sel.hairlength = ''; sel.hairtype = ''; }
      render();
    });
    card.addEventListener('input', function (ev) {
      if (ev.target.getAttribute && ev.target.getAttribute('data-f') === 'extra') sel.extra = ev.target.value;
    });
    card.addEventListener('change', function (ev) {
      var t = ev.target;
      if (t.classList.contains('ttic-consent-cb')) {
        window.ttEntityPhotoConsentGiven = t.checked;
        if (t.checked && !window.ttEntityConsentLogged && o.code) {
          window.ttEntityConsentLogged = true; // record it once per visit, same route as the main character consent
          fetch(WORKER_BASE + '/save-consent', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: o.code, consent_type: 'family_photo_likeness_biometric', consent_version: '1.0' }),
          }).catch(function () {});
        }
        render();
        return;
      }
      if (t.classList.contains('ttic-file')) {
        var file = t.files && t.files[0];
        if (!file) return;
        ph.file = file;
        try { ph.preview = URL.createObjectURL(file); } catch (e) { ph.preview = ''; }
        state = 'confirm';
        render();
      }
    });

    render();
    return card;
  }

  window.TTCast = { mountCard: mountCard, styles: ensureStyles, escapeHtml: escapeHtml, resize: readAndResizeImageFile };
})();